import { Text } from '@backend/lib-design-system';
import type { PropsWithChildren } from 'react';
import { styled } from 'styled-components';

import { Link } from '~/components/Link';

const StyledDropdownLink = styled(Link)`
  display: flex;
  padding: 12px 16px;
  color: ${({ theme }) => theme.palette.white};
  text-decoration: none;
  transition: background-color 0.2s;
  border-radius: 4px;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

const StyledDropdownLinkText = styled(Text)`
  display: flex;
  gap: 8px;
  align-items: center;
  color: ${({ theme }) => theme.palette.white} !important;
`;

type MenuDropdownLinkProps = {
  href: string;
};

export const MenuDropdownLink = ({ href, children }: PropsWithChildren<MenuDropdownLinkProps>) => (
  <StyledDropdownLink href={href}>
    <StyledDropdownLinkText variant="body-light" as="span">
      {children}
    </StyledDropdownLinkText>
  </StyledDropdownLink>
);
